// Same-host-relative paths are always safe. Cross-origin URLs are only
// accepted when the host is a fixrate platform domain — anything else is
// an open-redirect attempt and we drop it. We never accept javascript:
// or other non-http schemes.

const ALLOWED_HOST_SUFFIXES = ['.fixrate.no', '.fixrate.dev', '.fixrate.org', '.fixrate.se']

function isAllowedHost(hostname: string): boolean {
    const host = hostname.toLowerCase()
    if (host === 'fixrate.no' || host === 'fixrate.dev' || host === 'fixrate.org' || host === 'fixrate.se') {
        return true
    }
    return ALLOWED_HOST_SUFFIXES.some((suffix) => host.endsWith(suffix))
}

export function sanitizeOriginalUrl(raw: string | null | undefined): string | undefined {
    if (!raw) return undefined
    let parsed: URL
    try {
        parsed = new URL(raw, window.location.origin)
    } catch {
        return undefined
    }
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return undefined
    if (parsed.origin === window.location.origin) {
        return parsed.pathname + parsed.search + parsed.hash
    }
    // http:// is only legitimate for loopback during dev; require https
    // for cross-origin platform hosts.
    if (parsed.protocol !== 'https:') return undefined
    if (!isAllowedHost(parsed.hostname)) return undefined
    return parsed.toString()
}
